import script from "./ProfileHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileHero.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileHero.vue?vue&type=style&index=0&id=5def44bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5def44bb"]])

export default __exports__